import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef } from "react";
import PropTypes from "prop-types";
import { useDrag, useDrop } from "react-dnd";
import { DragItem as StyledDragItem } from "./dragItem.styles";
import { jsx as _jsx } from "react/jsx-runtime";
export var DragItem = function DragItem(_ref) {
  var id = _ref.id,
    children = _ref.children,
    index = _ref.index,
    moveItem = _ref.moveItem;
  var ref = useRef(null);
  var _useDrop = useDrop({
      accept: "item",
      collect: function collect(monitor) {
        return {
          handlerId: monitor.getHandlerId()
        };
      },
      hover: function hover(item, monitor) {
        var _ref$current;
        if (!ref.current) {
          return;
        }
        var dragIndex = item.index;
        var hoverIndex = index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
          return;
        }
        // Determine rectangle on screen
        var hoverBoundingRect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
        // Get vertical middle
        var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        var clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        var hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return;
        }
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return;
        }
        // Time to actually perform the action
        moveItem(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        item.index = hoverIndex;
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    handlerId = _useDrop2[0].handlerId,
    drop = _useDrop2[1];
  var _useDrag = useDrag({
      type: "item",
      item: function item() {
        return {
          id: id,
          index: index
        };
      },
      collect: function collect(monitor) {
        return {
          isDragging: monitor.isDragging()
        };
      }
    }),
    _useDrag2 = _slicedToArray(_useDrag, 2),
    isDragging = _useDrag2[0].isDragging,
    drag = _useDrag2[1];
  drag(drop(ref));
  return /*#__PURE__*/_jsx(StyledDragItem, {
    ref: ref,
    isDragging: isDragging,
    "data-handler-id": handlerId,
    children: children
  });
};
DragItem.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  moveItem: PropTypes.func.isRequired
};